import React, { useState, useEffect } from "react";
import axios from "axios";
import { Carousel, Table, Input, DatePicker, Modal, Card, Row, Col, message, Image, Checkbox, Button } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { ConsoleSqlOutlined, PlusOutlined, EditOutlined, CloseCircleOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
const { RangePicker } = DatePicker;
const { Meta } = Card;
const AdminCourseOutlineManage = () => {
    const navigate = useNavigate();
    return (
        <>
            <Row gutter={[8, 8]} justify={'center'}>
                <Col span={24} style={{ fontSize: '1rem', fontWeight: 500 }}>課綱內容</Col>
                <Col span={24}>
                    <TextArea rows={20}></TextArea>
                </Col>
                <Col>
                    <Button size='large'
                        // onClick={e => handleUpdate()} 
                        type="primary" block>更新</Button>
                </Col>
            </Row>
        </>
    )
}
export default AdminCourseOutlineManage;